/* MR Header — Sprint 7 (2026-07-18). One deferred file, budget ≤6KB min+gz.
   Spec: MR-Header-Implementation-Spec.md. No scroll listeners (sentinel IO),
   transform/opacity motion only, focus-trapped modals, background inert. */
(function () {
  'use strict';
  var d = document;
  var hd = d.querySelector('.mr-hd');
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- announcement dismiss (session-scoped; initial hide is inline in the section for CLS 0) --- */
  var ann = d.getElementById('mr-ann');
  if (ann) {
    var x = ann.querySelector('[data-mr-ann-x]');
    if (x) x.addEventListener('click', function () {
      try { sessionStorage.setItem('mr_ann_dismissed', '1'); } catch (e) {}
      if (reduce) { ann.hidden = true; return; }
      ann.style.height = ann.offsetHeight + 'px';
      void ann.offsetHeight;
      ann.classList.add('is-dismissing');
      ann.style.height = '0px';
      setTimeout(function () { ann.hidden = true; }, 260);
    });
  }

  if (!hd) return;

  /* --- sticky visual state via 80px sentinel IntersectionObserver (spec §4) --- */
  if ('IntersectionObserver' in window) {
    var sen = d.createElement('div');
    sen.setAttribute('aria-hidden', 'true');
    sen.style.cssText = 'position:absolute;top:0;left:0;width:1px;height:80px;margin:0;padding:0;pointer-events:none;visibility:hidden;';
    d.body.appendChild(sen);
    new IntersectionObserver(function (en) {
      hd.classList.toggle('is-scrolled', !en[0].isIntersecting);
    }).observe(sen);
  }

  /* --- modal plumbing (mobile menu + search sheet): trap, inert, restore --- */
  var FOC = 'a[href],button:not([disabled]),input:not([type=hidden]),select,textarea,[tabindex]:not([tabindex="-1"])';
  function focusables(el) {
    return [].filter.call(el.querySelectorAll(FOC), function (n) {
      return n.offsetParent !== null || n === d.activeElement;
    });
  }
  function setInert(on) {
    [].forEach.call(d.body.children, function (c) {
      if (c.contains(hd) || c.contains(openModal && openModal.el) || /^(SCRIPT|STYLE|LINK)$/.test(c.tagName)) return;
      if (on) c.setAttribute('inert', ''); else c.removeAttribute('inert');
    });
  }
  var openModal = null;
  function openModalEl(el, focusEl, trigger) {
    if (openModal) closeModal(true);
    openModal = { el: el, trigger: trigger };
    el.classList.add('is-open');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    setInert(true);
    d.documentElement.classList.add('mr-lock');
    var f = focusEl || focusables(el)[0];
    if (f) f.focus({ preventScroll: true });
  }
  function closeModal(skipFocus) {
    if (!openModal) return;
    var m = openModal;
    openModal = null;
    m.el.classList.remove('is-open');
    if (m.trigger) m.trigger.setAttribute('aria-expanded', 'false');
    setInert(false);
    d.documentElement.classList.remove('mr-lock');
    if (!skipFocus && m.trigger) m.trigger.focus({ preventScroll: true });
  }
  d.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (openModal) { e.preventDefault(); closeModal(); }
      else if (openDd) { ddSet(openDd, false); }
      return;
    }
    if (e.key !== 'Tab' || !openModal) return;
    var f = focusables(openModal.el);
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && d.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && d.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* --- mobile menu --- */
  var menu = d.getElementById('mr-menu');
  var burger = d.querySelector('[data-mr-menu-open]');
  if (menu && burger) {
    burger.addEventListener('click', function () {
      if (openModal && openModal.el === menu) closeModal();
      else openModalEl(menu, null, burger);
    });
    menu.addEventListener('click', function (e) {
      if (e.target.closest('[data-mr-menu-close]')) closeModal();
      else if (e.target.closest('a[href]')) closeModal(true);
    });
  }

  /* --- search sheet + predictive results (debounce 250ms, abort stale) --- */
  var search = d.getElementById('mr-search');
  if (search) {
    var input = search.querySelector('.mr-search__input');
    var list = search.querySelector('.mr-search__results');
    var status = search.querySelector('.mr-search__status');
    var sym = search.getAttribute('data-currency') || '';
    var base = ((window.routes && window.routes.predictive_search_url) || '/search/suggest') + '.json';
    var deb, ctrl;
    [].forEach.call(d.querySelectorAll('[data-mr-search-open]'), function (b) {
      b.addEventListener('click', function () {
        if (openModal && openModal.el === search) { closeModal(); return; }
        var bar = hd.querySelector('.mr-hd__bar');
        if (bar) search.style.setProperty('--mr-sheet-top', Math.max(0, bar.getBoundingClientRect().bottom) + 'px');
        openModalEl(search, input, b);
      });
    });
    search.addEventListener('click', function (e) {
      if (e.target.closest('[data-mr-search-close]')) closeModal();
    });
    d.addEventListener('click', function (e) {
      if (openModal && openModal.el === search && !search.contains(e.target) && !e.target.closest('[data-mr-search-open]')) closeModal(true);
    });
    var esc = function (s) { var n = d.createElement('div'); n.textContent = s == null ? '' : s; return n.innerHTML; };
    if (input && list) input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(deb);
      if (ctrl) ctrl.abort();
      if (q.length < 2) { list.innerHTML = ''; if (status) status.textContent = ''; return; }
      deb = setTimeout(function () {
        ctrl = window.AbortController ? new AbortController() : null;
        fetch(base + '?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=hide', ctrl ? { signal: ctrl.signal } : {})
          .then(function (r) { return r.json(); })
          .then(function (j) {
            var ps = (j && j.resources && j.resources.results && j.resources.results.products) || [];
            list.innerHTML = ps.slice(0, 6).map(function (p) {
              var u = p.featured_image && p.featured_image.url;
              var img = u ? '<img src="' + esc(u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=80') + '" width="40" height="40" loading="lazy" alt="">' : '';
              return '<li><a href="' + esc(p.url) + '">' + img + '<span class="mr-search__title">' + esc(p.title) + '</span><span class="mr-search__price">From ' + esc(sym + p.price) + '</span></a></li>';
            }).join('');
            if (status) status.textContent = ps.length ? ps.length + ' results' : 'No results';
          })
          .catch(function () {});
      }, 250);
    });
  }

  /* --- desktop dropdowns (hover intent 100ms, click, keys, one open) --- */
  var openDd = null;
  function ddSet(li, on) {
    var b = li.querySelector('[aria-controls]');
    li.classList.toggle('is-open', on);
    if (b) b.setAttribute('aria-expanded', on ? 'true' : 'false');
    if (on) {
      if (openDd && openDd !== li) ddSet(openDd, false);
      openDd = li;
    } else if (openDd === li) openDd = null;
  }
  [].forEach.call(hd.querySelectorAll('[data-mr-dd]'), function (li) {
    var b = li.querySelector('[aria-controls]');
    if (!b) return;
    var tOpen, tClose;
    li.addEventListener('mouseenter', function () {
      clearTimeout(tClose);
      tOpen = setTimeout(function () { ddSet(li, true); }, 100);
    });
    li.addEventListener('mouseleave', function () {
      clearTimeout(tOpen);
      tClose = setTimeout(function () { ddSet(li, false); }, 120);
    });
    b.addEventListener('click', function () { ddSet(li, !li.classList.contains('is-open')); });
    b.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        ddSet(li, true);
        var a = li.querySelector('.mr-dd a');
        if (a) a.focus();
      }
    });
    li.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.stopPropagation(); ddSet(li, false); b.focus(); }
    });
    li.addEventListener('focusout', function () {
      setTimeout(function () { if (!li.contains(d.activeElement)) ddSet(li, false); }, 0);
    });
  });
  d.addEventListener('click', function (e) {
    if (openDd && !openDd.contains(e.target)) ddSet(openDd, false);
  });
})();
